import { Disc3 } from 'lucide-react';
import { cn } from '@/utils';

const Spinner = ({ className }) => {
  return <Disc3 className={cn('animate-spin', className)} />;
};

export default Spinner;
